export default {"src":"/_next/static/media/1.2.d4e59eb8.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};